import React from "react";
import { Link } from "react-router-dom";
import StatusBadge from "../common/StatusBadge";
import { formatCurrency } from "../../lib/catalog";

export default function FlightCard({ item }) {
  return (
    <article className="card h-100 border-0 shadow-sm catalog-card package-card">
      <div className="card-body d-flex flex-column">
        <div className="package-card__top">
          <div className="text-uppercase text-secondary small fw-semibold package-card__code">
            {item.code || "No code"}
          </div>
          <StatusBadge className="flex-shrink-0" value={item.status || "Unknown"} />
        </div>

        <h5 className="card-title package-card__name" title={item.name}>
          {item.name}
        </h5>

        <div className="package-card__meta">
          <div className="package-card__row">
            <span className="package-card__label">Seats</span>
            <span className="package-card__value">{item.seats ?? "Not set"}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Child</span>
            <span className="package-card__value">{formatCurrency(item.childPrice)}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">PNR</span>
            <span className="package-card__value">{item.pnr || "Not set"}</span>
          </div>
        </div>

        <div className="package-card__footer mt-auto">
          <div className="package-card__prices">
            <div className="package-card__label">For Adult</div>
            <div className="package-card__net">{formatCurrency(item.adultPrice)}</div>
          </div>
          <Link to={`/flights/${item.id}`} className="btn btn-primary btn-sm package-card__book">
            Book
          </Link>
        </div>
      </div>
    </article>
  );
}
